module.exports = __webpack_public_path__ + "static/media/r257.c63b1aff.jpg";